export { default } from './radio-group';
//# sourceMappingURL=index.js.map